module.exports = __webpack_public_path__ + "img/jxjykf.9a3cdbc2.jpg";